import styled from '@emotion/styled'
import { styles } from 'app/theme'
import React, { memo } from 'react'
import { isMobile } from 'react-device-detect'

export interface Props {
  address?: string
  email?: string
  googleMapsURL?: string
  phone?: string
}

export const Contacts = memo(function Contacts({
  address,
  email,
  googleMapsURL,
  phone,
}: Props) {
  return (
    <Container>
      {address ? (
        <Text>
          <Anchor rel="noreferrer" target="_blank" href={googleMapsURL}>
            {address}
          </Anchor>
        </Text>
      ) : null}

      {email ? (
        <Text>
          <Anchor
            href={`mailto:${email}`}
            onClick={() => {
              typeof window.gtag !== 'undefined' &&
                window.gtag('event', 'Click', {
                  event_category: 'Website',
                  event_label: 'Email Address',
                })
            }}
          >
            {email}
          </Anchor>
        </Text>
      ) : null}

      {phone ? (
        <Text>
          <Anchor
            href={`tel:${phone}`}
            onClick={() => {
              if (isMobile) {
                typeof window.gtag !== 'undefined' &&
                  window.gtag('event', 'Click', {
                    event_category: 'Website',
                    event_label: 'Phone Number',
                  })
              }
            }}
          >
            {phone}
          </Anchor>
        </Text>
      ) : null}
    </Container>
  )
})

const Container = styled.div``

const Text = styled.div`
  ${styles.title.xs}

  margin-bottom: 1.25rem;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media (max-width: 1199px) {
    margin-bottom: 1.125rem;
  }
`

const Anchor = styled.a`
  display: inline-block;
  transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);

  &:hover {
    transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);
    opacity: 0.5;
  }
`
